import { ModalForm, ProForm, ProFormText } from '@ant-design/pro-components';
import { ConfigProvider, message } from 'antd';

interface ModalUpdatePasswordProps {
  trigger?: React.ReactElement;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

const ModalUpdatePassword = ({
  trigger,
  open,
  onOpenChange,
}: ModalUpdatePasswordProps) => {
  const [formPassword] = ProForm.useForm();

  return (
    <ConfigProvider componentSize="middle">
      <ModalForm
        form={formPassword}
        title="修改密码"
        layout="horizontal"
        labelCol={{ span: 4 }}
        width={500}
        trigger={trigger}
        open={open}
        onOpenChange={(open) => {
          if (!open) {
            formPassword.resetFields();
          }
          onOpenChange?.(open);
        }}
        onFinish={async (values) => {
          // 检查密码
          if (values.newPassword !== values.confirmPassword) {
            message.error('两次密码不一致');
            return false;
          }
          return true;
        }}
      >
        <ProFormText.Password
          name="password"
          label="原密码"
          rules={[{ required: true, message: '请输入原密码' }]}
        />
        <ProFormText.Password
          name="newPassword"
          label="新密码"
          rules={[{ required: true, message: '请输入新密码' }]}
        />
        <ProFormText.Password
          name="confirmPassword"
          label="确认密码"
          rules={[{ required: true, message: '请输入确认密码' }]}
        />
      </ModalForm>
    </ConfigProvider>
  );
};

export default ModalUpdatePassword;
